import styled from 'styled-components';
import { DEFAULT_IMG_USERS } from 'constants/urls';
import { randomColor } from 'utils/colors';

const SIZES = {
  xs: { wh: 25, fs: 12 },
  sm: { wh: 45, fs: 24 },
  md: { wh: 50, fs: 24 },
  invite: { wh: 44, fs: 24 },
  lg: { wh: 75, fs: 24 },
};

const LetterContainer = styled.div<{
  color: any;
  rounded: boolean;
  size: keyof typeof SIZES;
  $tinted?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ rounded }) => (rounded ? '50%' : '6px')};
  height: ${({ size }) => SIZES[size].wh}px;
  width: ${({ size }) => SIZES[size].wh}px;
  font-weight: 700;
  font-size: ${({ size }) => SIZES[size].fs}px;
  line-height: ${({ size }) => (SIZES[size].fs / 3) * 4}px;
  /* The tinted look is the invite designs': a 30% background and the colour's dark shade. */
  background: ${({ color, $tinted }) => ($tinted ? `${color.lighter}4D` : color.lighter)};
  color: ${({ color, $tinted }) => ($tinted ? color.dark : color.base)};
  font-family: ${({ $tinted }) => ($tinted ? "'Circular Std', Lato, sans-serif" : 'inherit')};
  font-feature-settings: ${({ $tinted }) => ($tinted ? 'normal' : 'inherit')};
  text-transform: uppercase;
`;

export interface ProfileImgProps {
  avatar?: string;
  name: string;
  email?: string;
  rounded?: boolean;
  size?: keyof typeof SIZES;
  avatarSize?: keyof typeof SIZES;
  tinted?: boolean;
}

export const AvatarLetter = ({
  avatar,
  name,
  email,
  rounded,
  size = 'md',
  avatarSize,
  tinted,
}: ProfileImgProps): JSX.Element => {
  if (avatar && avatar !== DEFAULT_IMG_USERS)
    return (
      <img
        src={avatar}
        width={avatarSize ? SIZES[size].wh : '50px'}
        height={avatarSize ? SIZES[size].wh : '50px'}
        style={{ borderRadius: rounded ? '50%' : '6px' }}
      />
    );
  else
    return (
      <LetterContainer
        rounded={rounded}
        size={size}
        $tinted={tinted}
        color={randomColor(email ? email : name)}
      >
        {name?.[0]}
      </LetterContainer>
    );
};

export default AvatarLetter;
